module.exports = __webpack_public_path__ + "media/images/img_class03-4d519b36ecd0cfbd4ae9e1ec95280506.jpg";